module.exports = __webpack_public_path__ + "img/art-36.383e0e9a.png";